/** Whether an issue identity can address server-only workflows (labels, comments and files).
 * Capture drafts are minted as tmp-* by extension usePinActions.ts:215,317;
 * localPinSave.ts:38-41 mints loc-* and saveLocalAnonymous.ts:193 marks them
 * isSynced after LOCAL persistence. Legacy local-* identities are local too.
 * finalizeCreatedPin.ts:110 adopts the create response id; localCaptureSync.ts:387
 * records that confirmed destination before further server writes.
 * This does not govern local editing or assignment.
 */
export function isServerIssueId(id) {
    return !!id && !/^(?:tmp-|loc-|local-)/.test(id);
}
//# sourceMappingURL=issueServerIdentity.js.map